import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73552b3f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-2 my-5 items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Link inválido ou expirado", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-4 mt-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "150",
    src: "/alert.png",
    alt: "Alerta"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "subtitle" }, "Solicite um novo link de recuperação de senha e tente novamente.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle mt-4" }, " Médicos podem recuperar a senha diretamente pelo aplicativo Minha Escala. ", -1))

import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import PATHS from '@/router/paths'

export default /*#__PURE__*/_defineComponent({
  __name: 'invalidTokenPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_router_link, {
      to: _unref(PATHS).FORGOTPASSWORD,
      class: "mt-5"
    }, {
      default: _withCtx(() => [
        _createVNode(OutlineButton, {
          text: "Solicitar novo link",
          width: "329px",
          "data-testid": "invalid-token-request-new-link-button"
        })
      ]),
      _: 1
    }, 8, ["to"]),
    _hoisted_5
  ]))
}
}

})